import { render, staticRenderFns } from "./feedBack_content.vue?vue&type=template&id=5f646524&scoped=true"
import script from "./feedBack_content.vue?vue&type=script&lang=js"
export * from "./feedBack_content.vue?vue&type=script&lang=js"
import style0 from "./feedBack_content.vue?vue&type=style&index=0&id=5f646524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f646524",
  null
  
)

export default component.exports